import script from "./ProductSpecial.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSpecial.vue?vue&type=script&setup=true&lang=js"

import "./ProductSpecial.vue?vue&type=style&index=0&id=45190003&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45190003"]])

export default __exports__